import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'abs'
})
export class AbsPipe implements PipeTransform {

    transform(value: number | null | undefined): number {
    return Math.abs(value ?? 0);
    }
}